import { useEffect, useRef } from "react";
import { useUserSector } from "@/core/hooks/useUserSector";

/**
 * Dispara `reset` quando o setor ativo MUDA (não no mount).
 *
 * SA-1212: filtros de tag são vocabulário do setor — mantê-los depois de trocar
 * de conta deixa a lista vazia sem chip visível para o usuário desfazer. Os
 * estados afetados vivem em stores/state locais das features (sobrevivem à
 * troca, que não remonta as páginas), então cada consumidor chama este hook com
 * o seu próprio reset.
 *
 * Não roda no mount de propósito: remontar a página (navegação, deep link) não
 * deve limpar um filtro que o usuário acabou de aplicar.
 */
export function useResetOnSectorChange(reset: () => void): void {
  const { activeSectorId } = useUserSector();
  const previousSectorId = useRef(activeSectorId);

  useEffect(() => {
    if (previousSectorId.current === activeSectorId) {
      return;
    }
    previousSectorId.current = activeSectorId;
    reset();
  }, [activeSectorId, reset]);
}
